<template>
  <div>
    <Head title="Keine Fragen im Wiederholungsmodus"/>
    <h1 class="h1">
      Fragen wiederholen
    </h1>
    <div class="mb-6 md:text-base max-w-2xl mx-auto px-4 ">

      <p class="h2 text-center font-normal md:mt-16">Nichts los hier – du hast derzeit<br> keine Fragen im Wiederholungsmodus.</p>

      <img src="/img/brand/chilling-fuchs.svg" alt="DGVT Fuchs chillt" class="mt-4 md:mt-16 max-w-sm mx-auto">
    </div>

  </div>
</template>

<script>
import Layout from '../../Shared/Layout'
import {Head} from '@inertiajs/inertia-vue3'


export default {
  name: 'Empty',

  components: {
    Head,
  },

  layout: Layout,

}
</script>

